import { render, staticRenderFns } from "./ItemTransfersIcon.vue?vue&type=template&id=33906164&"
import script from "./ItemTransfersIcon.vue?vue&type=script&lang=js&"
export * from "./ItemTransfersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports